var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_832_45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.243 12.1241H8.75696C8.33896 12.1241 8 12.4542 8 12.8612V42.1387C8 42.5457 8.33896 42.8758 8.75696 42.8758H45.243V42.8757C45.661 42.8757 46 42.5457 46 42.1387V12.8612C46 12.4542 45.661 12.1241 45.243 12.1241ZM31.4353 19.9158V13.5982H37.1294V19.9157C37.1294 20.0821 37.1401 20.2461 37.1591 20.4077C36.9189 21.7424 35.7209 22.7602 34.2824 22.7602C32.8439 22.7602 31.6459 21.7424 31.4057 20.4077C31.4246 20.2462 31.4353 20.0822 31.4353 19.9158ZM24.153 19.9158V13.5982H29.8471V19.9157C29.8471 20.0821 29.8579 20.2461 29.8768 20.4077C29.6366 21.7424 28.4386 22.7602 27.0001 22.7602C25.5616 22.7602 24.3635 21.7424 24.1234 20.4077C24.1422 20.2462 24.153 20.0822 24.153 19.9158ZM16.8706 19.9158V13.5982H22.5647V19.9157C22.5647 20.0821 22.5754 20.2461 22.5944 20.4077C22.3542 21.7424 21.1562 22.7602 19.7177 22.7602C18.2792 22.7602 17.0812 21.7424 16.841 20.4077C16.8599 20.2462 16.8706 20.0822 16.8706 19.9158ZM9.51391 18.6553V13.5982H15.2823V19.9157C15.2823 20.0821 15.2931 20.2461 15.312 20.4077C15.0719 21.7424 13.8738 22.7602 12.4353 22.7602C10.8245 22.7602 9.51391 21.4841 9.51391 19.9157V18.6553V18.6553ZM20.8685 41.4016H9.51391V36.3219H20.8685V41.4016ZM20.8685 34.8478H9.51391V27.7721H20.8685V34.8478ZM31.6175 41.4016H22.3825V27.7721H31.6175V41.4016ZM44.4861 41.4016H33.1315V36.3219H44.4861V41.4016ZM44.4861 34.8478H33.1315V27.7721H44.4861V34.8478ZM44.4861 26.298H32.3745H21.6255H9.51391V23.1611C10.2948 23.8284 11.317 24.2343 12.4353 24.2343C13.9418 24.2343 15.2746 23.4985 16.0765 22.3773C16.8784 23.4985 18.2111 24.2343 19.7176 24.2343C21.2241 24.2343 22.5568 23.4985 23.3588 22.3773C24.1607 23.4985 25.4934 24.2343 26.9999 24.2343C28.5065 24.2343 29.8392 23.4985 30.6411 22.3773C31.443 23.4985 32.7758 24.2343 34.2823 24.2343C35.7888 24.2343 37.1214 23.4985 37.9234 22.3773C38.7253 23.4985 40.058 24.2343 41.5645 24.2343C42.6828 24.2343 43.7049 23.8284 44.4859 23.1611V26.298H44.4861ZM44.4861 18.6553V19.9158C44.4861 21.4842 43.1755 22.7603 41.5647 22.7603C40.1262 22.7603 38.9281 21.7425 38.688 20.4078C38.7069 20.2462 38.7177 20.0822 38.7177 19.9158V13.5982H44.4861V18.6553V18.6553Z",
    fill: "#00C8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8964 33.9124C23.4784 33.9124 23.1394 34.2424 23.1394 34.6494V35.3127C23.1394 35.7197 23.4784 36.0498 23.8964 36.0498C24.3144 36.0498 24.6533 35.7197 24.6533 35.3127V34.6494C24.6534 34.2424 24.3144 33.9124 23.8964 33.9124Z",
    fill: "#00C8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.749 32.8068H37.4462C37.0282 32.8068 36.6893 33.1368 36.6893 33.5438C36.6893 33.9508 37.0282 34.2808 37.4462 34.2808H37.749C38.167 34.2808 38.506 33.9508 38.506 33.5438C38.506 33.1368 38.167 32.8068 37.749 32.8068Z",
    fill: "#00C8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9721 32.8068H40.0956C39.6776 32.8068 39.3386 33.1368 39.3386 33.5438C39.3386 33.9508 39.6776 34.2808 40.0956 34.2808H42.9721C43.3901 34.2808 43.7291 33.9508 43.7291 33.5438C43.7291 33.1368 43.3901 32.8068 42.9721 32.8068Z",
    fill: "#00C8C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_832_45",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_832_45"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_832_45",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.3db1ea85a8d80220dc06f8e66b149514.svg";
export { ForwardRef as ReactComponent };